import s from './title.module.scss'

export const Title = ({children,span,size}) => {
  return (
    <h2 style={{fontSize:size}} className={s.title}>{children} <span>{span}</span></h2>
  )
}
